import type { DashboardMessageId } from "./dashboard.fr";

/** Tableau de bord in Spanish. Same keys and {placeholders} as dashboard.fr.ts. */
export const dashboardEs: Record<DashboardMessageId, string> = {
  "dashboard.greeting": "Hola, {name}",
  "dashboard.subtitle": "{date} · Conakry",
  "dashboard.generatedAt": "Cifras leídas a las {time} (hasta un minuto de desfase).",
  "dashboard.refresh": "Actualizar",
  "dashboard.refreshing": "Actualizando…",
  "dashboard.loading": "Cargando el panel…",
  "dashboard.loadFailed": "No se pudo cargar el panel.",
  "dashboard.alertsAria": "Por atender ahora",
  "dashboard.alert.open": "Abrir →",
  "dashboard.alert.critical_report_open.tag": "Crítico",
  "dashboard.alert.critical_report_open.text": "{count} denuncia(s) crítica(s) abierta(s).",
  "dashboard.alert.critical_report_open.review":
    "{count} persona(s) suspendida(s) hasta una decisión del equipo; primera revisión antes del {date}.",
  "dashboard.alert.suspension_review_overdue.tag": "Revisión atrasada",
  "dashboard.alert.suspension_review_overdue.text":
    "{count} suspensión(es) superaron su plazo de revisión (la más antigua: {date}). Las personas siguen suspendidas hasta su decisión.",
  "dashboard.alert.cases_past_deadline.tag": "Atraso",
  "dashboard.alert.cases_past_deadline.text":
    "{count} expediente(s) superaron el plazo de primera respuesta ({hours} h).",
  "dashboard.alert.thin_coverage.tag": "Oferta",
  "dashboard.alert.thin_coverage.text":
    "{trade} en {city}: {requests} solicitudes hoy para {pros} pro(s) disponible(s). Aquí hay que reclutar.",
  "dashboard.alert.failed_payments.tag": "Pagos",
  "dashboard.alert.failed_payments.text": "{count} pago(s) Orange Money fallido(s) hoy.",

  "dashboard.card.demand": "Solicitudes del día",
  "dashboard.card.demand.answered": "Respondidas en menos de {hours} h",
  "dashboard.card.demand.unanswered": "Sin respuesta",
  "dashboard.card.demand.expired": "Caducadas",
  "dashboard.card.introductions": "Contactos establecidos",
  "dashboard.card.introductions.quotes": "Presupuestos enviados",
  "dashboard.card.introductions.median": "Plazo mediano de primera respuesta",
  "dashboard.card.introductions.cancelled": "Canceladas antes del contacto",
  "dashboard.card.pros": "Pros verificados",
  "dashboard.card.pros.unit": "activos",
  "dashboard.card.pros.new": "Nuevos en 7 días",
  "dashboard.card.pros.waiting": "Pendientes de verificación",
  "dashboard.card.pros.suspended": "Suspendidos",
  "dashboard.card.money": "Tarifas cobradas",
  "dashboard.card.money.failed": "Pagos Orange Money fallidos",
  "dashboard.card.money.approvals": "Solicitudes de aprobación pendientes",
  "dashboard.card.money.subscriptions": "Suscripciones mensuales activas",

  "dashboard.coverage": "Cobertura por oficio y municipio",
  "dashboard.coverage.empty": "No hay solicitudes hoy.",
  "dashboard.coverageFoot":
    "En rojo: menos de la mitad de las solicitudes respondidas a tiempo. Aquí hay que reclutar.",
  "dashboard.col.trade": "Oficio",
  "dashboard.col.commune": "Municipio",
  "dashboard.col.requests": "Solicitudes",
  "dashboard.col.pros": "Pros disp.",
  "dashboard.col.answered": "Respondidas < {hours} h",

  "dashboard.queues": "Colas de trabajo",
  "dashboard.noQueues": "No hay colas para sus roles.",
  "dashboard.queue.late_cases": "Expedientes atrasados",
  "dashboard.queue.open_cases": "Expedientes abiertos",
  "dashboard.queue.open_cases.meta": "{count} sin asignar",
  "dashboard.queue.identity_verifications": "Verificaciones de identidad",
  "dashboard.queue.identity_verifications.meta": "la más antigua espera desde hace {age}",
  "dashboard.queue.safety_reports": "Denuncias abiertas",
  "dashboard.queue.severity.critical": "{count} crítica(s)",
  "dashboard.queue.severity.high": "{count} alta(s)",
  "dashboard.queue.severity.medium": "{count} media(s)",
  "dashboard.queue.severity.low": "{count} baja(s)",
  "dashboard.queue.overdue_suspension_reviews": "Revisiones de suspensión atrasadas",
  "dashboard.queue.overdue_suspension_reviews.meta": "siguen suspendidos hasta una decisión",
  "dashboard.queue.payment_approvals": "Solicitudes de aprobación",
};
